import React from "react";
import { useEffect,useState,useRef } from "react";
import "./AllotedNotification.css";
import ApiManager from "../../ApiManager/ApiManager";
import Trips from "../Trips";


const AllotedNotification = ({tripId}) => {

    const [tripData, setTripData] = useState(null);
    const [message, setMessage] = useState(null)
    const [passengers, setPassengers] = useState(null);
    const [selectedEmails, setSelectedEmails] = useState([]);
    const textareaRef = useRef(null);

    const formatTimestamp = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp * 1000);
        return date.toLocaleString();
      };

      const handleMessageChange = (event) => {
        setMessage(event.target.value);
      };

      const handleAutoResize = () => {
        const textarea = textareaRef.current;
        if (textarea) {
        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`;
        }
      };

      const handleCheckboxChange = (email) => {
        setSelectedEmails((prevSelected) =>
            prevSelected.includes(email)
                ? prevSelected.filter((e) => e !== email)
                : [...prevSelected, email]
        );
    };

      const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                to: selectedEmails,
                subject: "Trip notification",
                body: message,
            };
            const response = await ApiManager.sendEmail(payload);
            console.log('Response:', response);
            if (!response.ok) throw new Error('API responded with an error');
            // alert('Form submitted successfully!');
        } catch (error) {
            console.error('Error submitting form:', error);
            // alert('Failed to submit the form.');
        }
    };

    useEffect(() => {
        const fetchData = async () => {
          try {
            const response = await ApiManager.getTripById(tripId);
            if (!response.ok) {
              throw new Error("Failed to fetch trip details");
            }
            const data = await response.json();
            if (data) {
              setTripData(data.trip);
              const passengerDetails = data.trip.passengers
                    .map((passenger, index) => `${index + 1}. Name: ${passenger.name},\n   Phone: ${passenger.phone},\n   Email: ${passenger.email}`)
                    .join("\n");
              setMessage(`Vehicle and Driver details:\n\n`+
                `Passenger Details:\n\n${passengerDetails}\n\n` +
                `- Trip Date and Time: ${formatTimestamp(data.trip.startTime)}\n`+
                `- Driver: ${data.trip.driver.name} (${data.trip.driver.phone})\n`+
                `- Vehicle: ${data.trip.car.vehicleName} (${data.trip.car.carTypeName})\n`+
                `- Reporting address: ${data.trip.reportingAddress}\n`+
                `- Drop address: ${data.trip.dropAddress}\n\n`+
                `Please ensure you are ready at the pickup location 5 mins before the scheduled time.\n\n`+
                `We wish you a safe and pleasant journey!\n\n`+
                `Best regards,\n`+
                `Ravi Travels`);
              setPassengers(data.trip.passengers)
            }
            
            console.log("trip data", data)
          } catch (error) {
            console.error("Error fetching trip details:", error);
          }
        };
    
        fetchData();
      }, [tripId]);

      useEffect(() => {
        handleAutoResize();
      }, [message]);

    return (
        <div className="alloted-notification">
            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Send SMS</th>
                        <th>Send Email</th>
                    </tr>
                </thead>
                <tbody>
                    {(passengers|| []).map(field => (
                        <tr>
                            <td>{field.name}</td>
                            <td>
                                <div className="checkbox-group">
                                    <input
                                        id="number"
                                        type="checkbox"
                                        disabled
                                    />
                                    <label htmlFor="number">{field.phone}</label>
                                </div>
                            </td>
                            <td>
                                <div className="checkbox-group">
                                    <input
                                        id={`email-${field.email}`}
                                        type="checkbox"
                                        onChange={() => handleCheckboxChange(field.email)}
                                    />
                                    <label htmlFor={`email-${field.email}`}>{field.email}</label>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <form action="display-message">
            <div className="textarea-group">
              <label>Message</label>
              <textarea
                id="tripMessage"
                ref={textareaRef}
                value={message || ""}
                className="input"
                rows="6"
                onChange={handleMessageChange}
                onInput={handleAutoResize} 
              >
              </textarea>
            </div>
            </form>

            <div className="all-checkboxes">
                <div className="checkbox-group">
                    <input
                        type="checkbox"
                        id="alloted_notification_checkbox1"
                    />
                    <label htmlFor="alloted_notification_checkbox1"> Add vehicle details</label>
                </div>
                <div className="checkbox-group">
                    <input
                        type="checkbox"
                        id="alloted_notification__checkbox2"
                    />
                    <label htmlFor="alloted_notification__checkbox2"> Add garage start time</label>
                </div>
                <div className="checkbox-group">
                    <input
                        type="checkbox"
                        id="alloted_notification__checkbox3"
                    />
                    <label htmlFor="alloted_notification__checkbox3"> Add entire booking dated</label>
                </div>
                <div className="checkbox-group">
                    <input
                        type="checkbox"
                        id="alloted_notification__checkbox4"
                    />
                    <label htmlFor="alloted_notification__checkbox4"> Add booking remarks</label>
                </div>
            </div>

            <button type="submit" onClick={handleSubmit}>Send</button>
        </div>
    )
};

export default AllotedNotification;